import { useEffect, useId, useRef, type ReactNode } from "react";
import { IconeFechar } from "../icones";

/**
 * Dialogo modal sobre o dialog nativo: prende o foco, Esc fecha e o leitor de tela anuncia. No celular vira uma
 * folha que sobe de baixo. `aoFechar` roda no Esc, no X e no clique fora. O conteudo so monta aberto. Ao abrir, o foco
 * fica na caixa (e nao no X, que ganhava o anel de foco sem ninguem ter tocado): o Tab segue pro X e pro conteudo.
 * `icone` (opcional) vai ao lado do titulo.
 */
export function Dialogo({ aberto, titulo, descricao, icone, aoFechar, children, rodape }: { aberto: boolean; titulo: string; descricao?: ReactNode; icone?: ReactNode; aoFechar: () => void; children?: ReactNode; rodape?: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  const caixa = useRef<HTMLDivElement>(null);
  const id = useId();
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (aberto && !d.open) {
      d.showModal();
      caixa.current?.focus();
    }
    if (!aberto && d.open) d.close();
  }, [aberto]);
  return (
    <dialog ref={ref} className="mtc-dialogo" aria-labelledby={`${id}-titulo`} onCancel={(e) => { e.preventDefault(); aoFechar(); }} onClick={(e) => { if (e.target === ref.current) aoFechar(); }}>
      {aberto && (
        <div ref={caixa} className="mtc-dialogo__caixa" tabIndex={-1}>
          <div className="mtc-dialogo__cabeca">
            {icone && <div className="mtc-dialogo__icone" aria-hidden>{icone}</div>}
            <div className="mtc-dialogo__textos">
              <h2 id={`${id}-titulo`} className="mtc-dialogo__titulo">{titulo}</h2>
              {descricao && <p className="mtc-dialogo__descricao">{descricao}</p>}
            </div>
            <button type="button" className="mtc-dialogo__fechar" onClick={aoFechar} aria-label="Fechar"><IconeFechar /></button>
          </div>
          {children}
          {rodape && <div className="mtc-dialogo__rodape">{rodape}</div>}
        </div>
      )}
    </dialog>
  );
}
